let Signatures = require('@/mixins/Signatures')

module.exports = {

    mixins: [Signatures],

    props: {
        postUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            secondsRemining: 60,
        }
    },

    created() {
        this.protectPostUrl()
    },

    mounted() {
        this.signaturePad = new SignaturePad(document.getElementById("signature-pad"));
    },

    methods: {

        save() {
            this.prepareData()
            this.form.post(this.postUrl).then(response => {
                Alert.withAction('Your signatures have been saved.').then(() => {
                    this.redirectTo(`/`);
                })
            }).catch(errors => {
                Alert.error(errors.first())
            })
        },

        protectPostUrl() {
            var expireAt = (new URL(this.postUrl)).searchParams.get('expires');
            var interval = setInterval(() => {
                this.secondsRemining = Math.abs(moment.duration(moment().diff(moment.unix(expireAt))).get('seconds'))
                if (this.secondsRemining == 0) {
                    clearInterval(interval)
                    this.refreshPage()
                }
            }, 1000)
        }
    },
}
